export const adaptTimeRange = (
  TimeS: string,
  TimeE: string,
  defaultStartTime?: string,
  defaultEndTime?: string
) => {
  const defaultValue =
    defaultStartTime && defaultEndTime
      ? `${defaultStartTime} - ${defaultEndTime}`
      : '10:00 - 22:00';

  if (TimeS && TimeE) {
    const [, timeSWithoutDate] = TimeS.split('T');
    const [hourS, minuteS] = timeSWithoutDate.split(':');
    const handledTimeS = `${hourS}:${minuteS}`;
    const [, timeEWithoutDate] = TimeE.split('T');
    const [hourE, minuteE] = timeEWithoutDate.split(':');
    const handledTimeE = `${hourE}:${minuteE}`;
    const handledTimeRange = `${handledTimeS} - ${handledTimeE}`;

    return handledTimeRange;
  } else {
    return defaultValue;
  }
};
